import React, {useState, useEffect} from 'react';
import {Row, Col, Divider, Table, Button, Tag, Space, Layout, Modal, Tooltip} from 'antd';
import moment from 'moment';
import {AdicionaSaldoItemNFe} from './adiciona-saldo-item-nfe';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxCheck } from '@fortawesome/pro-duotone-svg-icons';
import {useAxios} from '../../../../hooks';
import './detalhe-nfe-completa.scss';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

const { Footer, Content} = Layout;
const {confirm} = Modal;


const useNFeContra = ()=>{
    const {getApiEmitirNotas} = useAxios();

    const arquivaNFe = async(nfe) => {
        const api = await getApiEmitirNotas();
        
        const result = await api.get(`/fiscal/nfe-contra/${nfe.chaveNFe}/arquivar`);
        return result.data;
    }

    return {arquivaNFe};
}
const useMovimentacaoEstoque = () => {

    const {getApiEmitirNotas} = useAxios();
    const carregaMovimentacoes = async(uuidNFe) => {
        const api = await getApiEmitirNotas();
        const params = {
            uuidOrigem: uuidNFe,
            origem: "NFe"
        }
        const result = await api.get('/movimentacao-estoque', {params});
        return result.data;
    }

    
    const processaMovimentacoes = async (nfe) => {
        const api = await getApiEmitirNotas();
        const result = await api.post('/movimentacao-estoque/' + nfe.uuid);
        return result.data;
    }

    const removeMovimentacao = async (uuid) => {
        const api = await getApiEmitirNotas();
        const result = await api.delete('/movimentacao-estoque/' + uuid);
        return result.data;
    }

    return {carregaMovimentacoes, processaMovimentacoes, removeMovimentacao};
}

const DetalhaNFeCompleta = (props) => {

    const [mostrarAdicionaSaldo, setMostrarAdicionaSaldo] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState(false)
    const [movimentacoesAdicionadas, setMovimentacoesAdicionadas] = useState([]);
    const [ultimoUuidEditado, setUltimoUuidEditado] = useState('');
    const [loadingProcessamento ,  setLoadingProcessamento] = useState(false);
    const {carregaMovimentacoes, processaMovimentacoes, removeMovimentacao} = useMovimentacaoEstoque();
    const {arquivaNFe} = useNFeContra();
    const [arrLoadingRemoverBtn, setArrLoadingRemoverBtn] = useState({});
    const {nfe, aoFinalizarConferencia} = props;

    useEffect(() => {
        carregaMovimentacoesItens();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nfe]);

    const itensDebitadosNFe = [];

    nfe.itens.forEach(item => {
        
        itensDebitadosNFe[item.uuid] = {
            quantidadeDebitada: 0
        }
    })

    const carregaMovimentacoesItens = async () => {
        
        const movimentacoes = await carregaMovimentacoes(nfe.uuid);
        setMovimentacoesAdicionadas(movimentacoes);
    }

    const toogleMostrarAdicionaSaldo = () => {
        setMostrarAdicionaSaldo(!mostrarAdicionaSaldo);
    }

    const fecharTelaAdicionarSaldo = () => {
        setMostrarAdicionaSaldo(false);
    }

    const adicionarEmEstoqueHandle = item => () => {
        setItemSelecionado(item);
        toogleMostrarAdicionaSaldo();
    }

    const finalizarEntradaHandle = async () => {
        setLoadingProcessamento(true);
        await processaMovimentacoes(nfe);
        aoFinalizarConferencia();
    }

    const aoAdicionarMovimento = async (movimento) => {
        
        fecharTelaAdicionarSaldo();
        
        setUltimoUuidEditado(movimento.uuidItemOrigem);
        setTimeout(() => {
            setUltimoUuidEditado('');
        }, 5000);


        await carregaMovimentacoesItens();
    }


    const renderizaMeuProduto = (item) => {
        const movimentacoes = getMovimentacoesItem({item});
        const quantidadeDebitada = movimentacoes.reduce((anterior, mov) => anterior + parseFloat(mov.quantidadeOrigem), 0);
        if(parseFloat(item.quantidade) > parseFloat(quantidadeDebitada)){
            return (
                <Button size="small" danger={true} onClick={adicionarEmEstoqueHandle(item)}>Adicionar Em Estoque</Button>
            );
        } else {
            return (
                <Tag color="success">Produto Adicionado</Tag>
            );
        }
    }

    const removerHandle = (uuid, setLoading) => async () => {
        setLoading(true);
        setTimeout(async ()=>{
            await removeMovimentacao(uuid);
            await carregaMovimentacoesItens();

        }, 1000)
    }

    // const setLoadingRemoverBtn = (uuid, estado) => {
    //     const novoArr = arrLoadingRemoverBtn;
    //     novoArr[uuid] = estado;
    //     setArrLoadingRemoverBtn(novoArr);
    // }

    const renderizaMovimentacoesItem = (item) => {
        const movimentacoes = getMovimentacoesItem(item).map(mov => {
            const validade = mov.validade ? moment(mov.validade, 'YYYY-MM-DD').format("DD/MM/YYYY") : "";
            // setLoadingRemoverBtn(mov.uuid, false);
            
            const setLoading = (val) => {
                setArrLoadingRemoverBtn({[mov.uuid]: true})
                
            }
            return (<Row>
                <Col span={24}>
                    <FontAwesomeIcon icon={faBoxCheck}></FontAwesomeIcon>
                    <span>{mov.meuProduto.descricao} {mov.quantidade} {mov.meuProduto.uCom} </span>
                    <span>
                        Validade: {validade} &nbsp; 
                        Lote: {mov.lote} &nbsp;
                    </span>
                    <Button style={{float:"right"}} loading={arrLoadingRemoverBtn[mov.uuid]} onClick={removerHandle(mov.uuid, setLoading)} type="dashed" danger={true} size="small" icon={<FontAwesomeIcon icon={faTrash} />}> Remover</Button>
                </Col>
            </Row>)
        });

        return (<Space direction="vertical" style={{width:"100%"}}>{movimentacoes}</Space>);
    }

    const getMovimentacoesItem = item => {
        
        return movimentacoesAdicionadas.filter(mov => {
            return mov.item.uuid === item.item.uuid && mov.meuProduto != null;
        });
    }

    const existeMovimentacoesItemParaRenderizar = item => {
        return getMovimentacoesItem(item).length > 0;
    }

    
    const renderizaItensNFe = () => {
        
        const coluns = [{

            title: '#',
            dataIndex: 'nItem',
            sorter: {
                compare: (a, b) => {
                    console.log("a.nItem, b.nItem", a.nItem, b.nItem);
                    if(parseInt(a.nItem) > parseInt(b.nItem)){
                        return 1;
                    } else {
                        return -1;
                    }
                },
                
            },
            showSorterTooltip: false
            // render: (text, record, index)=>{
            //     return record.produto
            // }
            
            
        }, {

            title: 'Produto da NFe',
            dataIndex: 'descricao',
            sorter: {
                compare: (a, b) => a.descricao.localeCompare(b.descricao)
                
              },
            
            showSorterTooltip: false
            // render: (text, record, index)=>{
            //     return record.produto
            // }
            
            
        },{
            title: 'Qtd da Nota',
            dataIndex: 'quantidade',
            key: '3'
        },{
            title: 'Qtd Conferida',
            dataIndex: 'quantidadeAdicionada',
            key: '4'
        },{
            title: 'Meu Produto',
            key: "produtoVinculado",
            dataIndex: 'item',
            render: (item) => {
               return renderizaMeuProduto(item)
            }
        }];

        const itensNf = nfe.itens.map(item => {
            const {uuid, codigo, descricao,quantidade, unidadeComercial, totalItem, valorUn, valoresAdicionais, descontos, nItem} = item;
            console.log("ITEM", item)
            const movimentacoes = getMovimentacoesItem({item});
            let totalAdicionadoItemUnLocal = 0;
            let unidadeLocal = "";
            console.log("movimentacoes", movimentacoes);
            movimentacoes.forEach(mov => {
                totalAdicionadoItemUnLocal += mov.quantidade
                unidadeLocal = mov.meuProduto.uCom;
            })
            const quantidadeDebitada = getMovimentacoesItem({item}).reduce((itemAnterior, itemAtual) => {return itemAnterior + parseFloat(itemAtual.quantidadeOrigem)}, 0);
            let quantidadeAdicionada;
            
            if(totalAdicionadoItemUnLocal){
                quantidadeAdicionada = (<>
                    { quantidadeDebitada} {unidadeComercial} [{totalAdicionadoItemUnLocal} {unidadeLocal}] 
                </>);
            } else {
                quantidadeAdicionada = (<>
                    { quantidadeDebitada} {unidadeComercial} 
                </>);
            }


            return {
                
                codigo,descricao, totalItem, valorUn, item, nItem,
                produto: (<span><span className="codigo">{codigo}</span> {descricao}</span>), 
                key: uuid,
                quantidade: quantidade + " "+ unidadeComercial,
                quantidadeAdicionada,
                descAcr: valoresAdicionais - descontos

            }
        });

        return (<Table 
                    size="small" 
                    expandable={{
                        expandedRowRender: renderizaMovimentacoesItem,
                        rowExpandable: existeMovimentacoesItemParaRenderizar,
                    }}
                    rowClassName={(record, index) => record.key === ultimoUuidEditado ? 'ultimo-editado' :  ''}
                    pagination={false} 
                    onChange={()=>{}}
                    bordered={false} 
                    columns={coluns} 
                    dataSource={itensNf}></Table>);
        
    };

    const renderizaFormularioDeInserirSaldo = () => {
        if(itemSelecionado){
            return (<AdicionaSaldoItemNFe onSuccess={aoAdicionarMovimento} itemSelecionado={itemSelecionado} visible={mostrarAdicionaSaldo} onClose={fecharTelaAdicionarSaldo}></AdicionaSaldoItemNFe>);
        }
    }

    const renderizaFechamento = () =>{

        const arquivarDocumentoHandler = ()=> {
            confirm({
                title: "Tem Certeza disso?",
                content: "Após arquiar o documento não será mais possível dar entrada no estoque através dessa nota fiscal. Tem certeza que deseja arquivar essa NF-e?",
                cancelText: "Não",
                okText: "Sim, arquivar",
                onOk: async() => {
                    setLoadingProcessamento(true);
                    await arquivaNFe(nfe);
                    aoFinalizarConferencia();

                }
                
            })
        }
        return (
            <Row style={{
                textAlign: "right"
            }}>
                <Col span={24}>
                    <Button type="link" danger onClick={arquivarDocumentoHandler}>Arquivar Documento</Button> | <Button type="primary" onClick={finalizarEntradaHandle} loading={loadingProcessamento}>Finalizar Entrada</Button>
                </Col>
            </Row>
        )
    }

   

    return (<Layout style={{background: "#FFF", minHeight: "calc(100vh - 190px)"}}>
        <Content>

            <Row className="cabecalho">
                <Col span={12} className='dadosEmitente'>
                    <span className='nome'>{nfe.nome}</span>
                    <span className='documento'>CNPJ: {nfe.CNPJ}</span>
                    <span className='documento'>IE: {nfe.IE}</span>
                </Col>
                <Col span={12} className='dadosNFe'>
                    <span className='chaveNFe'>{nfe.chaveNFe}</span>
                    <span className="dataEmissao">{moment(nfe.dataEmissao).format('DD/MM/YYYY HH:mm:ss')}</span>
                </Col>
            </Row>
            <Divider></Divider>
            <Row>
                <h1 style={{
                    fontSize: '1.5em'
                }}>Itens</h1>
            </Row>
            <Space direction="vertical" style={{width: "100%"}}>
                <Row>

                    <Col span={24}>
                        {renderizaItensNFe()}
                    
                    </Col>

                    
                </Row>

            </Space>
        </Content>
        <Footer style={{
            padding: "0",
            background: "#FFF",
            marginTop: "23px"
        }}>
                {renderizaFechamento()}

        </Footer>
        {/* <Row>
        <Divider />
            <h1 className="titulo">Meu estoque</h1>
        </Row>
        <Row>
            <Col span={24}>
                
            
            </Col>

            

        </Row> */}
        

            {renderizaFormularioDeInserirSaldo()}

            

        
        
    </Layout>)
}

export {DetalhaNFeCompleta};